import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileAppearanceService } from "../../services/profile-appearance.service";

export const readProfileAppearanceByProfileId = createAsyncThunk(
  "profileAppearanceManage/readProfileAppearanceByProfileId",
  async (profileId, { rejectWithValue }) => {
    try {
      const response =
        await profileAppearanceService.readProfileAppearanceByProfileId(
          profileId
        );

        return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileAppearance = createAsyncThunk(
  "profileAppearanceManage/addProfileAppearance",
  async ({data, isFormData}, { rejectWithValue }) => {
    try {
      const response = await profileAppearanceService.addProfileAppearance(
        data,
        isFormData,
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileAppearance = createAsyncThunk(
  "profileAppearanceManage/editProfileAppearance",
  async ({ id, data , isFormData}, { rejectWithValue }) => {
    try {
      const response = await profileAppearanceService.editProfileAppearance(
        id,
        data,
        isFormData
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileAppearance = createAsyncThunk(
  "profileAppearanceManage/removeProfileAppearance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileAppearanceService.removeProfileAppearance(
        id
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
